import Wrapper from "./Wrapper.vue";

export default Wrapper;
